module.exports = __webpack_public_path__ + "static/media/error-icon.20068482.svg";